import { useEffect } from 'react';
import { useSelectionState } from '../../../components/SelectionStateProvider';
import { useSettings } from '../../Settings/SettingsProvider';
import { Port } from '../AISMapContext';
import { fromLonLat } from 'ol/proj';
import { Point } from 'ol/geom';

export function useFavoritePortOnStart() {
  const { setSelectedPorts, setPortSelectionMode } = useSelectionState();
  const { settings } = useSettings();

  useEffect(() => {
    // Only run if we have a favorite port configured
    if (!settings?.['ribbonPlugin.settings']?.favorite_port_data) {
      return;
    }

    const favoritePortData =
      settings['ribbonPlugin.settings'].favorite_port_data;

    // Create the Port object just like in PortSearch
    const selectedPort: Port = {
      id: favoritePortData.id.toString(),
      name: favoritePortData.name,
      country: favoritePortData.country,
      locode: favoritePortData.locode,
      geometry: new Point(
        fromLonLat(favoritePortData.position.coordinates as [number, number])
      ),
    };

    // Set mode to routes for startup (default behavior)
    setPortSelectionMode('routes');

    // Set the selected port (but don't zoom to it like PortSearch does)
    setSelectedPorts([selectedPort]);

    // Only run once on startup
  }, [
    settings?.['ribbonPlugin.settings']?.favorite_port_data,
    setSelectedPorts,
    setPortSelectionMode,
  ]);
}
